// src/app/contexts/adminTenant/Provider.jsx
import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { AdminTenantContext } from './context';

const STORAGE_KEY = 'henddu_admin_selected_tenant';

const readStoredTenant = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && parsed.id ? parsed : null;
  } catch {
    return null;
  }
};

export function AdminTenantProvider({ children }) {
  const [selectedTenant, setSelectedTenantState] = useState(readStoredTenant);

  // Keep state in sync with storage updates from other tabs
  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key !== STORAGE_KEY) return;
      setSelectedTenantState(readStoredTenant());
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  const selectTenant = useCallback((tenant) => {
    if (!tenant || !tenant.id) return;
    const payload = {
      id: tenant.id,
      name: tenant.name ?? '',
    };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    setSelectedTenantState(payload);
  }, []);

  const clearSelectedTenant = useCallback(() => {
    window.localStorage.removeItem(STORAGE_KEY);
    setSelectedTenantState(null);
  }, []);

  return (
    <AdminTenantContext.Provider
      value={{
        selectedTenant,
        selectTenant,
        clearSelectedTenant,
        hasSelectedTenant: !!selectedTenant?.id,
      }}
    >
      {children}
    </AdminTenantContext.Provider>
  );
}

AdminTenantProvider.propTypes = {
  children: PropTypes.node,
};
